import { async } from '@angular/core/testing';
import { Component, OnInit, Input } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '@app/service/common.service';

import { Globals } from '@app/service/globals.service';
import { HMemberService } from '@home/service/member.service';
import { RecruitService } from '@home/service/recruit.service';

import { ToastrService } from 'ngx-toastr';

import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

@Component({
  selector: 'app-recruit',
  templateUrl: './recruit.component.html',
  styleUrls: ['./recruit.component.scss']
})
export class RecruitComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  params: any = {
    tab: '',      // 구인, 구직 : offer, search
    type: '',     // 리스트, 내용보기, 쓰기, 수정 : list, view, write, modify
    boardSeq: 0,  // 게시판 순번
    no: 1,        // 현재 페이지
    row: 10,      // 페이지당 보여줄 갯수
  };

  public boardList: any = [];
  public totalCount = 0;
  public memberInfo: any = [];
  public maxSize: any = 10;

  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,

    private member: HMemberService,
    private recruitService: RecruitService,
    private globals: Globals,
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);

    if ( window.innerWidth <= 720 ) {
      this.maxSize = 3;
    }
  }

  ngOnInit(): void {
    // 멤버정보
    this.memberInfo$.subscribe( data => {
      if ( typeof data['memNo'] == 'undefined' )  {
        return false;
      } else {
        this.memberInfo = data;
      }
    });

    // 경로 정보 얻기
    this.activatedRoute.queryParams.subscribe(params => {
      this.params.tab = ( typeof params.tab === 'undefined' || params.tab == '' ) ? 'offer' : params.tab;
      this.params.type = ( typeof params.type === 'undefined' || params.type == '' ) ? 'list' : params.type;
      this.params.boardSeq = ( typeof params.boardSeq === 'undefined' || params.boardSeq == '' ) ? '0' : params.boardSeq;
      this.params.no = ( typeof params.no === 'undefined' || params.no == '' ) ? '1' : params.no;

      // 회원 검증
      this.member.getMemberInfo().then( response => {
        if (this.params.type === 'list') {
          if (this.params.tab === 'offer') {
            this.getBoardJobOfferList();
          } else if (this.params.tab === 'search') {
            this.getBoardJobSearchList();
          }
        }
      });
    });
  }

  /*******************************************************************************
    설  명 : 구인 게시판 리스트 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBoardJobOfferList() {
    this.recruitService.getBoardJobOfferList(this.params).then(response => {
      if ( response.ResultCode ) {
        this.boardList = response.data;
        this.totalCount = response.total;
      } else {
        this.boardList = [];
        this.totalCount = 0;
      }
      this.globals.indicator.next(false);
    }, error => {
      this.globals.indicator.next(false);

      this.toastrService.error('구인 리스트를 가져오는데 실패하였습니다.', '구인 리스트 정보');
    });
  }

    /*******************************************************************************
    설  명 : 구직 게시판 리스트 가져오기
    입력값 : 없음
    리턴값 : 없음
    *******************************************************************************/
   getBoardJobSearchList() {
    this.recruitService.getBoardJobSearchList(this.params).then(response => {
      if ( response.ResultCode ) {
        this.boardList = response.data;
        this.totalCount = response.total;
      } else {
        this.boardList = [];
        this.totalCount = 0;
      }
      this.globals.indicator.next(false);
    }, error => {
      this.globals.indicator.next(false);

      this.toastrService.error('구직 리스트를 가져오는데 실패하였습니다.', '구직 리스트 정보');
    });
  }

  /*******************************************************************************
    설  명 : 구인구직 변경
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  tabChange(tab) {
    this.params.tab = tab;
    this.params.type = 'list';
    this.params.boardSeq = '0';
    this.params.no = '1';

    this.linkRouter();
  }

  /*******************************************************************************
    설  명 : 게시판 상세보기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  view(row) {
    this.params.type = 'view';
    this.params.boardSeq = row.board_seq;
    this.linkRouter();
  }

  /*******************************************************************************
    설  명 : 신청하기 선택 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  write() {
    this.params.type = 'write';
    this.linkRouter();
  }

  /*******************************************************************************
    설  명 : 페이지 선택 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  loadPage(page) {
    this.params.no = page;
    this.linkRouter();
  }

  /*******************************************************************************
    설  명 : 라우터 변경
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  linkRouter() {
    this.router.navigate(
      [location.pathname],
      {
        relativeTo: this.activatedRoute,
        queryParams: this.params,
        queryParamsHandling: '', // remove to replace all query params by provided
    });
  }
}